import type { FrontendWidget } from '../types';
import { MagazineAuthorBoxComponent } from './MagazineAuthorBoxComponent';
import type {
  MagazineAuthorBoxConfig,
  MagazineAuthorBoxResolved,
} from './types';

/**
 * Inline, **context-backed** (30.03.05 § Classification): `resolveSync` and no
 * backend resolver — the block carries no fields and reads its entity from
 * `ctx.entities`.
 */
export const magazineAuthorBoxWidget: FrontendWidget<
  MagazineAuthorBoxConfig,
  MagazineAuthorBoxResolved
> = {
  componentType: 'magazine.author-box',
  displayName: 'Magazine Author Box',
  ComponentA: MagazineAuthorBoxComponent,
  resolveSync: () => ({}),
};
